import type { ComposeMode } from "@/lib/types/compose";
import type { StoredComposeSession } from "@/lib/compose/composeSessionsStore";

export type ComposePlacement = "inline" | "modal";

export function isInlineReplyMode(mode: ComposeMode): boolean {
  return mode === "reply" || mode === "replyAll";
}

export function isInlineComposeSession(session: StoredComposeSession | null | undefined): boolean {
  return session?.placement === "inline";
}

export function isModalComposeSession(session: StoredComposeSession | null | undefined): boolean {
  return session != null && session.placement !== "inline";
}
